import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormBuilder,FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "../../_services/toast.service";
import { TransportInterestService } from "../../_services/transport-interest.service";


@Component({
  selector: "app-transport-interest",
  templateUrl: "./transport-interest.component.html",
  styleUrls: ["./transport-interest.component.css"],
})
  
export class TransportInterestComponent implements OnInit {
  interestForm: FormGroup;
  demandId: number;
  token: string;
  isLoading = true;
  submitting: boolean = false;
  demandDetails: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private transportInterestService: TransportInterestService,
    private toast: ToastService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
        this.demandId = params['id'];
        this.token = params['token'];
        this.loadDemandDetails();
      });

    this.interestForm = this.fb.group({
      interest: ['', Validators.required],
      comment: ['']
    });
  }

  loadDemandDetails() {
    this.transportInterestService.getDemandDetails(this.demandId, this.token).subscribe({
      next: (response) => {
        this.demandDetails = response;
      },
      error: (error) => {
        this.toast.error('Erreur lors du chargement des détails de la demande');
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onSubmit() {
    if (this.interestForm.valid) {
      this.submitting = true;
      const formData = {
        ...this.interestForm.value,
        token: this.token,
      }

      this.transportInterestService.submitInterest(formData).subscribe({
        next: () => {
          this.toast.success('Votre réponse a été envoyée avec succès');
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.toast.error('Erreur lors de l\'envoi de votre réponse');
        },
        complete: () => {
          this.submitting = false;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/transport-interest/transport-interest.component.ts